import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "section section--mini screen-start notifications" }

import "./NotificationsView.scss";
import AdditionalLayout from "@/layouts/AdditionalLayout/AdditionalLayout.vue";
import {onMounted, ref} from "vue";
import {NotificationEntity} from "@/entities/NotificationEntity";
import Notification from "@/components/Notification/Notification.vue";
import {useUserStore} from "@/stores/userStore";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";
import {useNotificationsStore} from "@/stores/notificationsStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsView',
  setup(__props) {

let notificationsStore = useNotificationsStore();

let {notifications} = storeToRefs(notificationsStore);

onMounted(async () => {
	await notificationsStore.readAll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdditionalLayout, { title: "Notifications" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
          return (_openBlock(), _createBlock(Notification, {
            class: "notifications__item",
            key: notification.id,
            notification: notification
          }, null, 8, ["notification"]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})